import * as React from "react";
import IntegrationPanel from "../settings/IntegrationPanel";
import FlowConfigurationDescription from "./components/FlowConfigurationDescription";
import { VirtualConsultationFlowIntegration } from "./model/Flow";

interface SettingVirtualConsultationIntegrationProps {
  flowIntegration: VirtualConsultationFlowIntegration;
  isDmipPlatform: boolean;
}

export default function SettingVirtualConsultationIntegration(
  props: SettingVirtualConsultationIntegrationProps
) {
  return (
    <>
      <IntegrationPanel
        pageUrl={props.flowIntegration.pageUrl}
        scriptUrl={props.flowIntegration.scriptUrl}
        title={i18n["Page.Settings.Customisation.VirtualConsultation.Integration"]}
        pageSubtitleText={i18n["Page.Settings.Customisation.VirtualConsultation.Generic.Title"]}
        pageContentText={i18n["Page.Settings.Customisation.VirtualConsultation.Generic.Content"]}
        scriptSubtitleText={
          i18n["Page.Settings.Customisation.VirtualConsultation.Integration.Title"]
        }
        scriptContentText={
          i18n["Page.Settings.Customisation.VirtualConsultation.Integration.Content"]
        }
      />
      <FlowConfigurationDescription
        flowType={props.flowIntegration.flow.type}
        isDmipPlatform={props.isDmipPlatform}
      />
    </>
  );
}
